const E = "d-breadcrumbs__item--selected", e = "d-breadcrumbs--inverted";
export {
  e as BREADCRUMBS_INVERTED_MODIFIER,
  E as BREADCRUMB_ITEM_SELECTED_MODIFIER
};
//# sourceMappingURL=breadcrumbs-constants.js.map
